import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { MetricsElement } from 'react-metrics';
import CompareBar from '@hpstellar/core/CompareBar';

import WithCompare from './compare-container';
import { withError } from '../../shared/components/error-boundary';

function CompareDrawer(props) {
    const [collapse, setCollapse] = useState(false);
    const {
        compareProducts,
        toggleCompareProduct,
        clearCompareProducts,
        compareSlots,
        errors,
        headerComp,
        closeMaxedError,
        history,
        match,
    } = props;
    const { error, maxed } = errors;
    const compact = true;
    const full = compareProducts.length === compareSlots;
    const emptyItems = full
        ? []
        : Array.from(Array((error ? compareSlots - 1 : compareSlots) - compareProducts.length).keys());
    const currentCompareProducts = error && full ? compareProducts.slice(0, 3) : [...compareProducts];

    useEffect(() => {
        if (document) {
            const chatButton = document.getElementById('concierge');
            if (chatButton) chatButton.style.bottom = collapse ? '90px' : '220px';
        }

        if (maxed) {
            setCollapse(false);
        }

        return () => {
            if (document) {
                const chatButton = document.getElementById('concierge');
                if (chatButton) chatButton.style.bottom = '50px';
            }
        };
    }, [collapse, error, maxed]);

    const shouldRender = compareProducts.length >= 0;

    const compareBarProducts = products => {
        const res = products.map(p => {
            // TODO: temp detect if using old API
            if (p.name && p.imageUrl && p.listPrice) {
                return {
                    title: p.name,
                    image: { url: p?.imageUrl },
                    sku: p.sku,
                    price: { regularPrice: p.listPrice, salePrice: p.salePrice },
                };
            }
            ///

            return {
                title: p.title,
                image: { url: p?.images && p?.images[0].src },
                sku: p.sku,
                price: p.price,
            };
        });
        return res;
    };

    return (
        <>
            {headerComp(compareProducts.length, collapse)}
            {shouldRender && (
                <CompareBar
                    products={compareBarProducts(currentCompareProducts)}
                    maxCountToCompare={4}
                    onRemove={sku => {
                        toggleCompareProduct(compareProducts.filter(x => x.sku === sku)[0], true);
                    }}
                    onCompare={() => {
                        const { params } = match;
                        const { basename = '' } = params;
                        history.push(`${basename ? `/${basename}` : ''}/compare`);
                    }}
                    onClear={clearCompareProducts}
                    errorBar={{
                        isVisible: maxed,
                        title: 'YOU REACHED THE MAXIMUM NUMBER OF PRODUCTS TO COMPARE',
                        description: 'You can remove one of the products below and add a different one',
                        onClose: () => closeMaxedError(false),
                    }}
                />
            )}
        </>
    );
}

CompareDrawer.defaultProps = {
    compareSlots: 4,
    headerComp: () => {},
};

CompareDrawer.propTypes = {
    compareSlots: PropTypes.number,
    compareProducts: PropTypes.arrayOf(PropTypes.object).isRequired,
    toggleCompareProduct: PropTypes.func.isRequired,
    clearCompareProducts: PropTypes.func.isRequired,
    closeMaxedError: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
};

export default WithCompare(withRouter(withError(CompareDrawer)));
